import { z } from "zod/v4";

import { extractDiscriminatorEnum } from "../utils";

export const AlertSeverityList = [
  "success",
  "info",
  "warning",
  "error",
] as const;
export type AlertSeverity = (typeof AlertSeverityList)[number];

const GetProcessIdSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("putExperience"),
    experienceId: z.string(),
  }),
  z.object({
    type: z.literal("putExperienceError"),
    experienceId: z.string(),
  }),
  z.object({
    type: z.literal("getExperienceProductIssues"),
    experienceId: z.string(),
  }),
  z.object({
    type: z.literal("syncExperienceProducts"),
    experienceId: z.string(),
  }),
  z.object({
    type: z.literal("userError"),
    orgId: z.string(),
  }),
  z.object({
    type: z.literal("downloadExperience"),
    experienceId: z.string(),
    datasetId: z.string(),
  }),
  z.object({
    type: z.literal("startExperience"),
    experienceId: z.string(),
  }),
  z.object({
    type: z.literal("rolloutExperience"),
    experienceId: z.string(),
  }),
  z.object({
    type: z.literal("requestCogs"),
    orgId: z.string(),
    email: z.string(),
  }),
  z.object({
    type: z.literal("uploadCogsResult"),
    processId: z.string(),
  }),
  z.object({
    type: z.literal("uploadCogs"),
    orgId: z.string(),
  }),
  z.object({
    type: z.literal("duplicateExperience"),
    orgId: z.string(),
    originalExperienceId: z.string(),
  }),
  z.object({
    type: z.literal("syncPricingFunction"),
    orgId: z.string(),
  }),
  z.object({
    type: z.literal("fileBuild"),
    orgId: z.string(),
    experienceId: z.string().nullish(),
    variationId: z.string().nullish(),
  }),
  z.object({
    type: z.literal("billingRegression"),
    orgId: z.string(),
    regressionType: z.string(),
  }),
]);
export type GetProcessIdOptions = z.infer<typeof GetProcessIdSchema>;

export const ProcessTypeSchema = extractDiscriminatorEnum(GetProcessIdSchema);
export type ProcessType = z.infer<typeof ProcessTypeSchema>;

export const ProcessStatusTableDtoSchema = z.object({
  id: z.string(),
  orgId: z.string(),
  type: ProcessTypeSchema,
  severity: z.enum(AlertSeverityList),
  title: z.string(),
  isLoading: z.boolean().nullish(),
  loadingPercent: z.number().nullish(),
  message: z.string().nullish(),
  // @deprecated - use message input instead
  longMessage: z.string().nullish().meta({
    deprecated: true,
  }),
  action: z
    .object({
      href: z.string().nullish(),
      acknowledge: z.boolean().nullish(),
      deleteOnOpen: z.boolean(),
    })
    .nullish(),
  actionMessage: z.string().nullish(),
  email: z.email().nullish(),
  startTime: z.number(),
  dialogKey: z.string().nullish(),
  experienceId: z.string().nullish(),
});

export type ProcessStatusTableDto = z.infer<typeof ProcessStatusTableDtoSchema>;
